import Page from '@components/Page';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GetProcesses from '@helpers/GetProcesses';
import SchedulingService from '@services/graphQLSchedulingService';
import UserGroupService from '@services/UserGroupService';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import { Checkbox, Divider, Modal, Select, Steps } from 'antd';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import { safePropertieRetrieve } from '@src/helpers/validation/ObjectValidator';
import { isFilledArray } from '@src/helpers/validation/arrayValidators';
import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

import { LocalStorageKeys } from '../../containers/App';
import Calendar from '../Calendar';
import {
  CalendarContainer,
  CalendarFilters,
  ContainerCircle,
  ItemDiv,
  ModalContainer,
  OptionsContainer,
} from './schedulerStyles';
import { safePropertieRetrieve } from '@src/helpers/validation/ObjectValidator';
import { isFilledArray } from '@src/helpers/validation/arrayValidators';
import GroupService from '@services/graphQL/graphQLGroup'

const groupService = new GroupService()
const moment = require('moment')

type StateType = {
  eventCreationModalVisibility: boolean;
  events: any;
  repetitionFrequency: number;
  scheduleStep: number;
  slotDate?: string[];
  scheduledDay?: number;
  scheduledMonth?: number;
  scheduledYear?: number;
  unitID: string;
  processes: any;
  editionMode: boolean;
  selectedProcessID?: string;
  groups: any;
  selectedUserGroup?: any;
  scheduleName?: string;
  scheduledHour?: any;
  timeString?: string;
  eventId?: string;
  scheduleFilters?: Array<any>;
  currentFilter?: Array<Number|String>;
  disableSave: boolean;
  idsToDelete: string[];
}

type PropType = {

}



export default class SchedulerContainer extends Component<PropType, StateType> {

  private _userGroupService: UserGroupService;
  private _schedulingService: SchedulingService;

  constructor(props: PropType) {
    super(props)

    this._userGroupService = new UserGroupService();
    this._schedulingService = new SchedulingService();

    this.state = {
      eventCreationModalVisibility: false,
      events: [],
      repetitionFrequency: 1,
      scheduleStep: 0,
      editionMode: false,
      unitID: String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID)),
      processes: [],
      groups: [],
      selectedProcessID: undefined,
      selectedUserGroup: undefined,
      scheduleName: undefined,
      timeString: undefined,
      eventId: undefined,
      scheduleFilters: [
        { type: 'overdue', value: 5, label: I18n.l('schedule.filter.OVERDUE') },
        { type: 'pendent', value: 1, label: I18n.l('schedule.filter.PENDENT') },
        { type: 'in-progress', value: 2, label: I18n.l('schedule.filter.INPROGRESS') },
        { type: 'done', value: 3, label: I18n.l('schedule.filter.DONE') }
      ],
      currentFilter: [5,1,3,2],
      disableSave: false,
      idsToDelete: []
    }
  }

  getGroups = async () => {
    try {
      let { listUserGroups }: any = await groupService.listUserGroups()
      this.setState({ groups: listUserGroups })

    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e)
      console.error(e)
    }
  }

  UNSAFE_componentWillMount() {
    this.initialData();
    this.deleteInexistentIds();
  }

  deleteInexistentIds =  async () => {
    const { idsToDelete } = this.state;
    const toBedeleted: any = []
    if(isFilledArray(idsToDelete)){
      for(let id of idsToDelete){
        toBedeleted.push(this._schedulingService.deleteSchedule(id))
      } 
    }
    await Promise.all(toBedeleted)
    }

  initialData = async () => {
    await Promise.all([
      this.setProcesses(), 
      this.getGroups(), 
    ])
    this.getEvents()
    this.deleteInexistentIds();
  }

  deleteInexistentIds =  async () => {
    const { idsToDelete } = this.state;
    const toBedeleted: any = []
    if(isFilledArray(idsToDelete)){
      for(let id of idsToDelete){
        toBedeleted.push(this._schedulingService.deleteSchedule(id))
      } 
    }
    await Promise.all(toBedeleted)
  }  

  getEvents = async () => {
    let data: any = await this._schedulingService.listAll()
    const now = moment().format('YYYY-MM-DD HH:mm:ss')
 
    const events: any = []
    const idsToDelete: any = [];
    const processMemoization = {};
    
    
    data = data.listSchedules.forEach((e: any) => {
      const endDate = new Date(e.to)
      const end = moment(endDate).format('YYYY-MM-DD HH:mm:ss')
      const isOverdue = now > end && e.status !== 3;
 
      //memoization
      let title;
      if(processMemoization[e.processId]){
        title = processMemoization[e.processId];
      } else {
        const { processes } = this.state;
        const titleObject = processes.items.find((process: any) => process.id === e.processId);
        title = safePropertieRetrieve(titleObject, 'name') || '';
        processMemoization[e.processId] = title;
      }

      if(title !== ''){
        const returnedObj = {
          title,
          realName: e.title,
          start: new Date(e.from),
          end: endDate,
          allday: false,
          processId: e.processId,
          groupId: e.groupId[0].split(',').map((r: any) => Number(r)),
          id: e.id,
          status: isOverdue ? 5 : e.status,
          process: e.process
        }
        events.push(returnedObj)
        return 
      }

      idsToDelete.push(e.id);
    })
    await this.setState({ events, idsToDelete })
  }
  

  setProcesses = async () => {
    const processes = await GetProcesses(this.state.unitID)
    this.setState({ processes })
  }
  selectSlotHandler = async (slot: any) => {
    this.clearAppState();
    const slotDate = slot.slots[0]
    const year = eval(slotDate.toString().split(' ')[3])
    this.setState({
      scheduledDay: slotDate.getDate(),
      scheduledMonth: slotDate.getMonth(),
      scheduledYear: year
    })

    if (slot.action === 'click') {
      this.setState({ eventCreationModalVisibility: true })
      let time: any = new Date(slot.slots[0]);
      time = time.getTime()
    }
  }
  selectEventHandler = async (event: any) => {
    const date = new Date(event.start)
    let from = date.toString().split(' ')[4]
    from = from.substr(0, 5)
    let scheduledHour = [date.getHours(), date.getMinutes()]
    this.setState({
      scheduleName: event.realName,
      selectedProcessID: event.processId,
      eventId: event.id,
      selectedUserGroup: event.groupId,
      timeString: from,
      scheduledDay: date.getDate(),
      scheduledMonth: date.getMonth(),
      scheduledYear: date.getFullYear(),
      scheduledHour: scheduledHour,
    })
    this.setState({ editionMode: true })
    this.setState({ eventCreationModalVisibility: true })
  }
  closeEventsModal = async () => {
    await this.clearAppState()
  }
  returnIcon = (icon: string, label: string) => {
    return (
      <ItemDiv >
        <ContainerCircle>
          <FontAwesomeIcon icon={`${icon}`} />
        </ContainerCircle>
        <p>{I18n.l(`${label}`)}</p>
      </ItemDiv>
    )
  }

  setFrequency = async (e: any) => {
    this.setState({ repetitionFrequency: e.target.value })
  }

  handleHourSelect = async (e: any) => {
    if(e.target.value.indexOf('_') === -1){
      
      let timeArray = e.target.value.split(':')
      timeArray = timeArray.map((e: string) => {
      if (e.indexOf('0') === 0) {
        e = e.slice(e.indexOf('0') + 1, e.length)
      }

      return eval(e)
    })
      this.setState({ scheduledHour: timeArray })
    }
  }

  setSelectedProcess = async (selectedProcessID: string) => {
    this.setState({ selectedProcessID: selectedProcessID })
  }
  selectUserGroup = async (selectedUserGroup: any) => {
    this.setState({ selectedUserGroup })
  }

  setScheduleName = async (e: any) => {
    this.setState({ scheduleName: e.target.value })
  }

  createSchedule = async () => {
    this.setState({ disableSave: true })
    try {
      if(!this.state.selectedUserGroup){
        throw ""
      }
      const fromTimeStamp = new Date(this.state.scheduledYear, this.state.scheduledMonth, this.state.scheduledDay, this.state.scheduledHour[0], this.state.scheduledHour[1]).getTime()
      const fromDate = new Date(fromTimeStamp)
      const toDate = new Date(fromTimeStamp + 6000)
      let scheduleJSON = {
        title: this.state.scheduleName,
        from: fromDate.getTime().toString().substr(0,10),
        to: toDate.getTime().toString().substr(0,10),
        processId: this.state.selectedProcessID,
        groupId: Array.isArray(this.state.selectedUserGroup) ? this.state.selectedUserGroup : [this.state.selectedUserGroup], 
        properties: {}
      }
      const data = await this._schedulingService.create(scheduleJSON)
      const eventsList = this.state.events
      
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      const end = moment(toDate).format('YYYY-MM-DD HH:mm:ss')
      let isOverdue = false
      if (now > end) {
        isOverdue = true
      }

      eventsList.push({
        title: this.state.processes.items.filter((r: any) => r.id === this.state.selectedProcessID)[0].name,
        realName: this.state.scheduleName,
        start: fromDate,
        end: toDate,
        allday: false,
        processId: this.state.selectedProcessID,
        groupId: Array.isArray(this.state.selectedUserGroup) ? this.state.selectedUserGroup : [this.state.selectedUserGroup], 
        id: data.putSchedule.id,
        status: isOverdue ? 5 : 1
      })
      this.setState({ events: eventsList })
      this.clearAppState()
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('select.group.scheduler'))
      this.setState({ disableSave: false })
      console.error(e)
    }
  }

  clearAppState = async () => {
    this.setState({
      eventCreationModalVisibility: false,
      scheduledDay: undefined,
      scheduledMonth: undefined,
      scheduledYear: undefined,
      scheduledHour: undefined,
      scheduleStep: 0,
      scheduleName: '',
      selectedProcessID: undefined,
      selectedUserGroup: undefined,
      timeString: '',
      editionMode: false,
      disableSave: false
    })
  }

  nextScheduleStep = async () => {
     if(!this.state.scheduleName){
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('schedule.title'))
    }
    else if (!this.state.selectedProcessID) {
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('select.process'))
    }else if(!this.state.scheduledHour){
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('insert.time'));
    }
    else if (!this.state.scheduledHour[0] && this.state.scheduledHour[0] !== 0 || !this.state.scheduledHour[1] && this.state.scheduledHour[1] !== 0) {
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('insert.time'));
    }else {
      this.setState({ scheduleStep: 1 });
    }

  }

  editSchedule = async () => {
    this.setState({ disableSave: true })
    try {
      const fromTimeStamp = new Date(this.state.scheduledYear, this.state.scheduledMonth, this.state.scheduledDay, this.state.scheduledHour[0], this.state.scheduledHour[1]).getTime();
      const fromDate = new Date(fromTimeStamp);
      const toDate = new Date(fromTimeStamp + 6000);
      const events = this.state.events;
      const currentEvent = this.state.events.find((e: any) => e.id === this.state.eventId);

      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      const end = moment(toDate).format('YYYY-MM-DD HH:mm:ss')
      let isOverdue = false
      if (now > end) {
        isOverdue = true
      }

      const newGroupIds = Array.isArray(this.state.selectedUserGroup) ? this.state.selectedUserGroup : [this.state.selectedUserGroup]
      const bkpGroups = [...newGroupIds]

      let editedEvent: any = {
        title: this.state.processes.items.filter((r: any) => r.id === this.state.selectedProcessID)[0].name,
        realName: this.state.scheduleName,
        allday: false,
        from: fromDate.getTime().toString().substr(0,10),
        to: toDate.getTime().toString().substr(0,10),
        groupId: newGroupIds.map((r: any) => `${r}`),
        processId: this.state.selectedProcessID,
        status: isOverdue ? 5 : 1
      }
      await this._schedulingService.editSchedule(currentEvent.id, editedEvent)
      const fromTimeString = editedEvent.from + '000'
      const toTimeString = editedEvent.to + '000'
      editedEvent['start'] = new Date(parseInt(fromTimeString))
      editedEvent['end'] = new Date(parseInt(toTimeString))
      delete editedEvent['from']
      delete editedEvent['to']
      editedEvent.groupId = bkpGroups
      editedEvent.id = currentEvent.id
      events[events.indexOf(currentEvent)] = editedEvent
      this.setState({ events })
      await this.clearAppState();
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ disableSave: false })
      console.error(e)
    }
  }

  deleteSchedule = async () => {

    try {
      let events = this.state.events.filter((e: any) => e.id !== this.state.eventId);
      await this._schedulingService.deleteSchedule(this.state.eventId);
      this.setState({ events })
      await this.clearAppState()
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e)
      console.error(e)
    }
  }
  returnModalContent = () => {
    const { processes, groups, selectedUserGroup, scheduleName, disableSave, scheduledHour } = this.state
    let timeString;
    if(scheduledHour){
      timeString = scheduledHour.map((e:any) => {
        if(e){
          e = e.toString()
          if(e.length == 1){
            e = '0'+e;
          }
          return e;
        }
        return '00';
      })
      timeString = timeString.join("");
    }
    switch (this.state.scheduleStep) {
      case 0:
        return (
          <OptionsContainer>
            <div className="desc-container">
              <p>{I18n.l('scheduler.schedule.description')}</p>
            </div>
            <div className="title-container">
              <p>{I18n.l('schedule.title')}</p>
              <input value={scheduleName} onChange={this.setScheduleName} className="title-input" />
            </div>
            <div className="select-process">
              <div className="required-label">
                <p>{I18n.l('scheduled.process')}</p>
                <span className="text-label">
                  <p>{I18n.l('formflow.labels.required')}</p>
                </span>
              </div>
              {processes && processes.items &&
                <Select key={this.state.selectedProcessID} onChange={this.setSelectedProcess} defaultValue={this.state.selectedProcessID} placeholder={I18n.l('auditconf.processSelectPlaceholder')}>
                  {processes && processes.items && processes.items.map((e: any) => <Select.Option value={e.id} key={e.id}>{e.name}</Select.Option>)}
                </Select>}
            </div>

            <div className="select-time-container">
              <div className="required-label">
                <p>{I18n.l('process.time')}</p>
                <span className="text-label">
                  <p>{I18n.l('formflow.labels.required')}</p>
                </span>
              </div>
              <div>
                <MaskedInput defaultValue={timeString} onChange={this.handleHourSelect} className="time-input" mask={[/[0-2]/, /[0-9]/, ':', /[0-6]/, /[0-9]/]} placeholder={'--:--'} />

              </div>
              <div className="options-buttons">
                <button onClick={this.closeEventsModal} className="no-bg">{I18n.l('common.cancel')}</button>
                {this.state.editionMode && <button style={{ color: '#e03f3f' }} className="no-bg" onClick={this.deleteSchedule}>{I18n.l('common.delete')}</button>}
                <button onClick={this.nextScheduleStep} className="pill-button">{I18n.l('common.next')}</button>
              </div>
            </div>

          </OptionsContainer>)
      case 1:
      return (
          <OptionsContainer>
            <div className="desc-container">
              <p>{I18n.l('scheduler.user.select.description')}</p>
            </div>
            <div className="user-group-container">
              <div className="required-label">
                <p>{I18n.l('select.user.group')}</p>
                <span className="text-label">
                  <p>{I18n.l('formflow.labels.required')}</p>
                </span>
              </div>
              <Select filterOption={(input: any, option: any) => option.props.label.toLowerCase().includes(input.toLowerCase())} mode="multiple" key={selectedUserGroup} defaultValue={selectedUserGroup} onChange={this.selectUserGroup} placeholder={I18n.l('scheduled.group')} className="user-group-select">
                {groups && groups.map((e: any) => <Select.Option
                value={e.id}
                key={e.id}
                label={e.name}>{e.name}</Select.Option>)}
              </Select>

              <div className="options-buttons margin-top">
                <button onClick={() => this.setState({ scheduleStep: 0 })} className="no-bg">{I18n.l('common.back')}</button>
                {this.state.editionMode && <button style={{ color: '#e03f3f' }} className="no-bg" onClick={this.deleteSchedule}>{I18n.l('common.delete')}</button>}
                <button onClick={this.state.editionMode ? this.editSchedule : this.createSchedule} disabled={disableSave} className="pill-button">{I18n.l('common.save')}</button>
              </div>
            </div>
          </OptionsContainer>
        )
      default:
        return
    }
  }

  onChangeFilters = (checkedValues: any) => {
    this.setState({ currentFilter: checkedValues })
  }

  renderFilterButtons = () => {
    const { scheduleFilters } = this.state

    return (
      <div>
        <CheckboxGroup onChange={this.onChangeFilters} defaultValue={this.state.currentFilter}>
          {scheduleFilters && scheduleFilters.map(r => {
            return <Checkbox value={r.value} className={r.type}>{r.label}</Checkbox>
          })}
        </CheckboxGroup>
      </div>
    )
  }

  getFilteredEvents = () => {
    return this.state.events.filter((r: any) => {
      return this.state.currentFilter.includes(r.status)
    })
  }

  render() {
    const messages = {
      previous: `${I18n.l("common.previous")}`,
      next: I18n.l("common.next"),
      month: I18n.l("auditconf.goalsmonth"),
      week: I18n.l("common.week"),
      day: I18n.l("frequency.days"),
      agenda: I18n.l('all.schedules'),
      date: I18n.l("form.taskflowschedule.labels.date"),
      today: I18n.l("common.today")
    }
    const { Step } = Steps
    const { eventCreationModalVisibility, scheduleStep } = this.state

    return (
      <Page>
        <div>
          <Modal
            destroyOnClose={true}
            visible={eventCreationModalVisibility}
            onCancel={this.closeEventsModal}
            footer={null}
            width={'40%'}
          >
            <ModalContainer>
              <Steps current={scheduleStep}>
                <Step icon={this.returnIcon('calendar-alt', 'actions.schedule')} />
                <Step icon={this.returnIcon('user', 'common.users')} />
              </Steps>
              <Divider style={{ width: '133%' }} />
            </ModalContainer>
            {this.returnModalContent()}
          </Modal>

          <CalendarFilters>
            {this.renderFilterButtons()}
          </CalendarFilters>

          <CalendarContainer>
            <Calendar messages={messages} selectSlotHandler={this.selectSlotHandler} selectEventHandler={this.selectEventHandler} events={this.getFilteredEvents()} />
          </CalendarContainer>
        </div>
      </Page>
    )
  }
}
